import(/* webpackMode: "eager", webpackExports: ["NewRelic"] */ "/home/yeet/.volt/artifacts/content/apps/programs/src/components/NewRelic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AssetLoadErrorHandler","isAssetLoadError","recover"] */ "/home/yeet/.volt/artifacts/content/libs/components/ErrorHandler/AssetLoadErrorHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/home/yeet/.volt/artifacts/content/libs/components/ErrorHandler/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/home/yeet/.volt/artifacts/content/libs/components/WebVitals/WebVitals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CohesionConfigProvider"] */ "/home/yeet/.volt/artifacts/content/libs/providers/CohesionConfig.tsx");
;
import(/* webpackMode: "eager" */ "/home/yeet/.volt/artifacts/content/node_modules/next/dist/client/script.js");
